<template>
  <div class="pagination-wrapper">
    <ul class="pagination pagination-sm">
      <li
        v-for="(pageNumber, idx) in visiblePageNumbers"
        :key="idx"
        :class="{
          active: pageNumber === page,
          disabled: pageNumber === 'SEPARATOR',
        }"
      >
        <a v-if="pageNumber === 'SEPARATOR'">...</a>
        <router-link
          v-if="pageNumber !== 'SEPARATOR'"
          :to="getRouteForPage({ pageNumber })"
        >
          {{ pageNumber }}
        </router-link>
      </li>
    </ul>
    <span v-if="showTotal" class="total-label text-muted">
      Total: {{ total }} {{ totalItemsLabel }}
    </span>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    page: Number,
    pageSize: { type: Number, default: 24 },
    total: Number,
    showTotal: { type: Boolean, default: false },
    showAtLeastOnePage: { type: Boolean, default: false },
  },
  computed: {
    totalItemsLabel() {
      if (this.total === 1) {
        return 'item'
      } else {
        return 'items' // yes, it should be "Total 0 items" for zero too
      }
    },
    visiblePageNumbers() {
      if (!this.total) {
        if (this.showAtLeastOnePage) {
          return [1]
        } else {
          return []
        }
      }
      const r = 2
      let pages = _.range(this.page - r, this.page + r + 1)
      pages = pages.filter((p) => {
        return p >= 1 && p <= this.totalPages
      })

      // always add first and last page - and separator if needed
      // but there is only small gap (one number) put that number instead of separator
      if (pages[0] !== 1) {
        if (pages[0] === 2) {
          pages = [1].concat(pages)
        } else if (pages[0] === 3) {
          pages = [1, 2].concat(pages)
        } else {
          pages = [1, 'SEPARATOR'].concat(pages)
        }
      }
      if (pages.length > 0 && _.last(pages) !== this.totalPages) {
        if (_.last(pages) === this.totalPages - 1) {
          pages = pages.concat([this.totalPages])
        } else if (_.last(pages) === this.totalPages - 2) {
          pages = pages.concat([this.totalPages - 1, this.totalPages])
        } else {
          pages = pages.concat(['SEPARATOR', this.totalPages])
        }
      }

      return pages
    },
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    },
    showLeftSeparator() {
      return (
        this.visiblePageNumbers.length > 1 && this.visiblePageNumbers[1] !== 2
      )
    },
    showRightSeparator() {
      const prevLastIdx = this.totalPages
      return (
        this.visiblePageNumbers.length > 2 &&
        this.visiblePageNumbers[prevLastIdx] !== this.totalPages - 1
      )
    },
  },
  methods: {
    getQueryParams({ pageNumber }) {
      return Object.assign({}, this.$route.query, { page: pageNumber })
    },
    getRouteForPage({ pageNumber }) {
      if (this.$route && this.$route.name) {
        return {
          name: this.$route.name,
          params: this.$route.params,
          query: this.getQueryParams({ pageNumber }),
        }
      } else {
        return {}
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  .pagination {
    float: left;
  }

  .total-label {
    float: left;
    font-size: 16px;
    margin: 28px 0 0 10px;
  }
}
</style>
